import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';

// 1. Combine reducers properly
const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  product: productReducer,
  cart: cartReducer,
});

// 2. Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['ui', 'cart'],
};

// 3. Wrap reducer correctly
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4. Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// 5. Persistor
export const persistor = persistStore(store);